<template>
  <div>
    <validation-observer ref="form" tag="div">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('odoo_limit_obligor_groups.group_code'))"
          class="col-md-6"
          vid="group_code"
          rules="required"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('odoo_limit_obligor_groups.group_code'))"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
        >
        <b-form-input
              id="group_code"
              v-model="model.alias_code"
              :state="errors[0] ? false : validated ? true : null"
              name="group_code"
              required
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('odoo_limit_obligor_groups.group_name'))"
          class="col-md-6"
          vid="group_name"
          rules="required"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('odoo_limit_obligor_groups.group_name'))"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
        >
        <b-form-input
              id="group_name"
              v-model="model.alias_name"
              :state="errors[0] ? false : validated ? true : null"
              name="group_name"
              required
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import FormModel from "./model";

export default {
  extends: FormModel,
  data() {
    return {
      region: null,
      model: {
        ...this.value,
        alias_code: this.value.alias_code ?? null,
        alias_name: this.value.alias_name ?? this.value.name ?? null,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../design/custom/components/required-field-asterisk";

::v-deep {
  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }

  .col-form-label {
    font: 800 14px/20px Lato, 'sans-serif' !important;
    color: #182230 !important;
  }
}
</style>

<style lang="scss" scoped>

.section-title {
  font-weight: 800;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.05em;
  color: #0084f3;
}

::v-deep {
  table {
    thead {
      background: #f9fafb !important;
    }
  }

  .border-tab {
    border: 1px solid #D0D5DD;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .nav-link {
    font: 600 14px/20px 'Inter', 'sans-serif';
    color: black;

    &.custom-active-nav {
      border-bottom: 2px solid #0083F2 !important;
      color: #0083F2 !important;
    }
  }

  .vs__selected-options input {
    padding: 4px 16px;
  }
}

.card-form {
  max-width: 720px;
}
</style>

<style lang="scss">
.vs__dropdown-menu {
  z-index: 9999 !important;
}

.button-add-bank {
  transition: background .2s ease-in;
  border-radius: 0;

  &:hover {
    background: #EEF3F7;
  }
}
</style>
